import { BelegungsIntervall } from '@/domain/dienstplan/shared/types/Belegung';

export function isMouseIntersectInterval(
  intervall: BelegungsIntervall[],
  position: { x: number; y: number },
  start: { x: number; y: number },
): boolean {
  for (let index = 0; index < intervall.length; index++) {
    const element = intervall[index];

    if (start.x <= element.startX && position.x >= element.startX) {
      return true;
    }

    if (
      start.x >= element.startX + element.width &&
      position.x <= element.startX + element.width
    ) {
      return true;
    }
  }
  return false;
}
